module.exports = __webpack_public_path__ + "static/img/Jark_StickJcy.a1165bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Jark_StickJcy.jpg
// module id = QOh4
// module chunks = 1